import { ClientCreation, ClientRaw } from '@Arti-zen/package-backoffice'
import { styled } from 'styled-components'
import { Theme } from 'theme/theme'

type TProps = {
  clients: ClientRaw[]
  newHeaders: Record<string, Set<string>>
  expectedColumns: (keyof ClientCreation)[]
  prettifyColumns: Record<string, string>
}

export default function ExempleClient({ clients, newHeaders, expectedColumns, prettifyColumns }: TProps) {
  const newColumns = expectedColumns.map((prop) => [...newHeaders[prop]])
  const reversePrettifyColumns = Object.fromEntries(Object.entries(prettifyColumns).map(([key, value]) => [value, key]))

  return (
    <div>
      <p>Exemple avec les 10 premiers clients du fichier CSV :</p>
      <ExempleClientWrapper>
        <Row>
          {expectedColumns.map((col, index) => (
            <Column key={`col-${index}`}>
              <h3>{prettifyColumns[col]}</h3>
            </Column>
          ))}
        </Row>
        {clients.map((client, index) => (
          <Row key={`product-exemple-${index}`}>
            {newColumns.map((columns, indexCol) => {
              const values = columns
                .map(
                  (column) =>
                    client?.[prettifyColumns[column]] ?? client?.[reversePrettifyColumns[column]] ?? client?.[column]
                )
                .filter(Boolean)
                .join(' - ')

              return (
                <Column key={`value-${index}-${indexCol}`}>
                  {values ? <p>{values.length > 50 ? `${values.slice(0, 50)}...` : values}</p> : <p>_</p>}
                </Column>
              )
            })}
          </Row>
        ))}
      </ExempleClientWrapper>
    </div>
  )
}

const ExempleClientWrapper = styled.div`
  padding: 10px;
  border: 1px solid ${Theme.colors.blueArtizen};
  border-radius: 5px;
  text-align: center;
  h3 {
    margin: 5px 0 0 0;
    font-size: 15px;
    flex: 1;
  }
  p {
    flex: 1;
  }
`

const Row = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  padding: 10px;
  align-items: center;
`

const Column = styled.div`
  flex: 1 1 0;
  min-width: 0;
  p,
  h3 {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`
